// app/javascript/services/admissoes_approvals_service.js

function tokenFromMeta() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute("content") : null;
}

function csrfToken() {
  return tokenFromMeta();
}

function normalizeUrlToPath(url) {
  if (!url) return url;
  let stripped = String(url).replace(/^https?:\/\/[^/]+/i, "");
  if (stripped[0] !== "/") stripped = "/" + stripped;
  return stripped;
}

function extractErrorMessage(resp) {
  try {
    if (resp && resp.responseJSON) {
      return resp.responseJSON.error || resp.responseJSON.message || "Erro desconhecido";
    }
  } catch (e) { }
  return "Falha ao processar. Verifique o console.";
}

function postWithCsrf(url, data = {}) {
  const token = csrfToken();
  const payload = { ...data };
  if (token) payload.authenticity_token = token;

  return $j.ajax({
    url: normalizeUrlToPath(url),
    method: "POST",
    data: payload,
    headers: token ? { "X-CSRF-Token": token } : {},
  });
}

export function createAdmissoesApprovalsService({ bulkUrl }) {
  return {
    async confirmCancel() {
      const result = await Swal.fire({
        title: "Cancelar minha aprovação?",
        html: '<p class="text-center">Deseja cancelar sua aprovação desta solicitação de admissão?</p>',
        icon: "warning",
        confirmButtonText: "Sim, cancelar",
        confirmButtonColor: "#d33",
        showCancelButton: true,
        cancelButtonColor: "#6b7280",
        cancelButtonText: "Voltar",
        showCloseButton: true,
      });
      return !!result.isConfirmed;
    },

    async confirmBulkApprove(count) {
      const result = await Swal.fire({
        title: "Aprovar admissões?",
        html: `<p class="text-center">Você irá aprovar <b>${count}</b> solicitação(ões) de admissão.</p>`,
        icon: "question",
        confirmButtonText: "Sim, aprovar",
        confirmButtonColor: "#28a745",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
      });
      return !!result.isConfirmed;
    },

    async bulkApprove(ids) {
      if (!bulkUrl) throw new Error("bulkUrl não informado.");
      return postWithCsrf(bulkUrl, { ids });
    },

    async cancelApproval(url) {
      if (!url) throw new Error("URL de cancelamento não informada.");
      return postWithCsrf(url, {});
    },

    async rejectItem(url) {
      if (!url) throw new Error("URL de rejeição não informada.");
      const result = await Swal.fire({
        title: "Rejeitar admissão?",
        html: '<p class="text-center">Tem certeza que deseja rejeitar esta solicitação?</p>',
        icon: "warning",
        confirmButtonText: "Sim, rejeitar",
        confirmButtonColor: "#d33",
        showCancelButton: true,
        cancelButtonColor: "#6b7280",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
      });
      if (!result.isConfirmed) return;
      return postWithCsrf(url, {});
    },

    showError(title, respOrMessage) {
      const msg = typeof respOrMessage === "string" ? respOrMessage : extractErrorMessage(respOrMessage);
      return Swal.fire({
        title: title || "Erro",
        html: `<p class="text-center">${msg}</p>`,
        icon: "error",
      });
    },
  };
}
